
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ModalContent from "@/components/modal/ModalContent.vue";
import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";
import SkillsMultiselect from "@/components/autocompleteMultiselects/SkillsMultiselectNew.vue";
import FormWrapper from "@/components/form/FormWrapper.vue";
import FormGroup from "@/components/form/FormGroupCustom.vue";
import UIButton from "@/components/button/ui-button.vue";
import LanguagesMultiselect from "@/components/autocompleteMultiselects/LanguagesMultiselectNew.vue";
import CrossIconHover from "@/components/icons/CrossIconHover.vue";
import DeleteGray from "@/components/icons/DeleteGray.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import CrossIcon from "@/components/icons/CrossIconNew.vue";
import { Language, User_Language } from "@/generated/graphql";
import DropdownOption from "@/entities/DropdownOption";

@Component({
  components: {
    ModalContent,
    LanguagesMultiselect,
    ModalFullScreen,
    SkillsMultiselect,
    CrossIconHover,
    FormWrapper,
    FormGroup,
    UIButton,
    CrossIcon,
    DeleteGray,
    LoadingOverlay,
  },
})
export default class ManagementAddContractorInfo extends Vue {
  @Prop({ type: Array, required: false })
  readonly language?: [];
  @Prop({ type: String, required: true }) readonly contractorUserId!: string;
  @Prop({ type: String, required: true }) readonly currentUserId!: string;

  isHovered: boolean = false;
  languages: Language[] = [];
  loading = false;
  allLanguages: DropdownOption[] = [];

  mounted() {
    this.languages = this.language;
  }

  closeModal(): void {
    this.$emit("close");
  }

  addLang() {
    this.$emit("add-languages", this.languages);
    this.closeModal();
  }
}
